// extracted by mini-css-extract-plugin
export var body = "_i6-0";
export var sectionHeader = "_i6-4";
export var shortcutColumns = "_i6-2";
export var shortcutList = "_i6-1";
export var shortcutSection = "_i6-3";